// question and answer for pricing
export const pagePricingData = {
  "en": {
    sectionHero: {
      pretitle: "Pricing",
      title: "One tool for your whole team Free for personal use", 
    },
    sectionComparison: {
      title: "Compare plans & features",
    },
    sectionQa: {
      title: "Questions and Answers",
      qaSets : [{
          q: 'What are my payment options?',
          a: 'You can pay with credit card. For the Enterprise Plan, we can issue an annual invoice and you can pay by bank transfer or cheque.'
        }, {
          q: 'Which plan should I choose?',
          a: "If you expect to collaborate with team members on the same projects, choose the Team Plan. If you have enterprise needs like designated customer success and priority support, the Enterprise plan will suit your needs.\n\nIf you do not need team collaboration, the free Personal Plan offers 100 projects, unlimited channels and 2,500 monthly active users which will meet many individuals' needs. The Personal Pro Plan meets the needs of power users with unlimited projects and unlimited storage.\n\nIt is easy to change plans so you can start with whichever best suits you."
        },  {
          q: 'What is a monthly active user?',
          a: 'A monthly active user is an end-user who has interacted (sent or received) with your bot in the month.'
        },  {
          q: 'What happens when I go over the monthly active users limit while on the free plan?',
          a: 'Upgrade to the Personal Pro plan, which has 5,000 monthly active users included and can support additional monthly active users beyond 5,000 for a fee.'
        },  {
          q: 'Can I use Delight for free indefinitely?',
          a: 'Absolutely! You can use Delight for free indefinitely.'
        },  {
          q: 'Can I change from a free plan to a paid plan, or from paid to free?',
          a: 'Yes, you can upgrade or downgrade your plan as you like.'
        },  {
          q: 'What happens when I change plans?',
          a: 'Your account will be credited or charged based on percentage of billing cycle left at the time you change plans.'
        },  {
          q: 'Do you have volume discounts?',
          a: 'We offer customized pricing for large enterprises with high usage. If you expect more than 50,000 monthly active users, contact us for volume discounts.'
        },  {
          q: 'Do you offer discounts to non-profit organizations and schools?',
          a: 'Delight wants to empower organizations who do good. So we offer special discount pricing to qualified non-profit organizations, schools and students. Contact us for details.'
        },  {
          q: 'Do you offer startup discounts?',
          a: 'Delight believes in empowering entrepreneurs and startups. We offer startup discounts through qualified partners like select investors and startup ecosystem builders. If you are not referred by a qualified partner but have an interesting use case for Delight, contact us.'
        },  {
          q: 'Do you offer e-commerce integration?',
          a: 'If you are using e-commerce integration, Delight offers a distinct, free product so you can bring your e-commerce storefront to voice and chat channels for free. See please free pricing for e-commerce integration /link/pricing-ecommerce .'
        }
      ]
    }
  },
  "zh": {
    sectionHero: {
      pretitle: "方案定价",
      title: "一个团队 统一工具 个人用家 费用全免", 
    },
    sectionComparison: {
      title: "方案及特色比较",
    },
    sectionQa: {
      title: "常见问题",
      qaSets : [{
          q: '有哪些付款方式？',
          a: '进阶及团队方案，敝号接受信用卡付款。我们可为企业客户提供发票，并接纳支票及银行转账。'
        }, {
          q: '我该选择哪个方案与定价？',
          a: "如果您需要与团队合作，共同建立同一项目，请选用团队方案。\n\n如您是企业代表，有品牌商标的顾虑，希望得到指定客服经理，提供优先支援，企业方案将会是您的最佳选择。\n\n如果您是个人用家，并不需要和团队合作,预计不会建立超过100个项目，也不会有庞大的客户流量，那么个人免费方案，将是一个简单快捷的好开始。知名度高、使用量也大的用家，则可考虑进阶方案，可得到无上限的数据用量。\n\n您可以随时转换方案，节省成本，成效更高。"
        },  {
          q: '每月活跃用户如何计算？',
          a: '每月活跃用户是指，每月新使用您语音APP的用户。'
        },  {
          q: '免费方案下的每月活跃用户量，如果超出上限，要如何处理？',
          a: '升级至进阶方案，限额即时提升一倍，至5,000个；往后的用户数量，可依需求增购。'
        },  {
          q: 'Delight的免费方案真的无限期？',
          a: '是的。这个方案可以永久享用。'
        },  {
          q: '我可否由免费方案升级到付费方案，或者由付费转为免费方案？',
          a: '可以的。您可以按需要，随时转换至不同方案。'
        },  {
          q: '转换方案后，我要做什么？',
          a: '您的户口或者出现付费方案的剩余结余，升级的话便会被收取升级定价。'
        },  {
          q: '您会否提供批量折扣？',
          a: '需求量大的话，欢迎向我们查询企业方案的定价。如果您预计活跃用户将会超出50,000个，请联络我们的销售代表，查询批量折扣。'
        },  {
          q: '您会否提供折扣优惠予非牟利组织或学校团体？',
          a: 'Delight Labs一直希望回馈社会。符合资格的公益组织、学校团体及学生，均可联络我们，查问特别优惠。'
        },  {
          q: '初创企业可有折扣优惠？',
          a: 'Delight Labs同为初创企业，当然希望服务初创企业。我们欢迎投资者或创业领袖为我们引荐初创伙伴。如您没有引荐人，请直接与我们联络。'
        }, {
          q: 'Delight 可有电子商务整合服务？',
          a: '如果您已开创了网上商店，Delight随时为您免费连接商店到不同语音频道。'
        }
      ]
    }
  },
  "zh-hk": {
    sectionHero: {
      pretitle: "方案定價",
      title: "一個團隊 一個工具 個人用家 費用全免", 
    },
    sectionComparison: {
      title: "方案及特色比較",
    },
    sectionQa: {
      title: "常見問題",
      qaSets : [{
          q: '有哪些付款方式？',
          a: '進階及團隊方案，敝號接受信用卡付款。我們可為企業客戶提供發票，並接納支票及銀行轉賬。'
        }, {
          q: '我該選擇哪個方案與定價？',
          a: "如果您需要與團隊合作，共同建立同一項目，請選用團隊方案。\n\n如您是企業代表，有品牌商標的顧慮，希望得到指定客服經理，提供優先支援，企業方案將會是您的最佳選擇。\n\n如果您是個人用家，並不需要和團隊合作, 預計不會建立超過100個項目，也不會有龐大的客戶流量，那麼個人免費方案，將是一個簡單快捷的好開始。知名度高、使用量也大的用家，則可考慮進階方案，可得到無上限的數據用量。\n\n您可以隨時轉換方案，節省成本，成效更高。"
        },  {
          q: '每月活躍用戶如何計算？',
          a: '每月活躍用戶是指，每月新使用您語音APP的用戶。'
        }, {
          q: '免費方案下的每月活躍用戶量，如果超出上限，要如何處理？',
          a: '升級至進階方案，限額即時提升一倍，至5,000個；往後的用戶數量，可依需求增購。'
        },  {
          q: 'Delight 的免費方案真的無限期？',
          a: '是的。這個方案可以永久享用。'
        },  {
          q: '我可否由免費方案升級到付費方案，或者由付費轉到免費方案？',
          a: '可以的。您可以按需要，隨時轉換至不同方案。'
        },  {
          q: '轉換方案後，我要做甚麼？',
          a: '您的戶口或者出現付費方案的剩餘結餘，升級的話便會被收取升級定價。'
        },  {
          q: '您會否提供批量折扣？',
          a: '需求量大的話，歡迎向我們查詢企業方案的定價。如果您預計活躍用戶將會超出50,000個，請聯絡我們的銷售代表，查詢批量折扣。'
        },  {
          q: '您會否提供折扣優惠予非牟利組織或學校團體？',
          a: 'Delight Labs 一直希望回饋社會。合資格非牟利組織、學校團體及學生，均可聯絡我們，查問特別優惠。'
        },  {
          q: '初創企業可有折扣優惠？',
          a: 'Delight Labs 同為初創企業，故然希望服務初創企業。我們歡迎投資者或創業圈領袖為我們引薦初創伙伴。如您未有引薦人，請直接與我們聯絡。'
        }, {
          q: 'Delight 可有電子商務整合服務？',
          a: '如果您已擁有網上商店，Delight 可以隨時為您免費連接商店至不同語音頻道。'
        }
      ]
    }
  },
}


// export const pricingItems = [
//   [
//     { 
//       category: 'individual',
//       id: 'personal',
//       title: 'Perso',
//       priceFree: '$0',
//       buttonTxt: 'Get started',
//       summary: 'For everyone trying out Delight for an unlimited period of time',
//       heading: 'Free for individuals',
//       items: ['Unlimited channels', '200 projects', '2500 MAU included', 'Sandbox and publishing service'] 
//     },
//     {
//       category: 'individual',
//       id: 'personal-pro',
//       title: 'Personal Pro',
//       priceAnnual: '$8',
//       priceMonthly: '$10',
//       unitOne: 'per month',
//       buttonTxt: 'Try it free',
//       summary: 'For power users who want to do more',
//       heading: 'Everything in Personal, plus',
//       items: ['Unlimited channels', 'Unlimited storage', '5000 MAU included']
//     }
//   ],
//   [
//     {
//       category: 'business',
//       id: 'team',
//       title: 'Team',
//       priceAnnual: '$15',
//       priceMonthly: '$20',
//       unitOne: 'per member',
//       unitTwo: 'per month',
//       buttonTxt: 'Try it free',
//       summary: 'For teams working together on the same project',
//       heading: 'Everything in Personal Pro, plus',
//       items: ['Team collaboration', 'Unlimited team members', 'Premium Templates', 'Unlimited conversation history']
//     },
//     {
//       category: 'business',
//       id: 'enterprise',
//       title: 'Enterprise',
//       priceCustom: 'Contact sales →',
//       buttonTxt: 'Try it now',
//       summary: 'For businesses with support and customer success needs',
//       heading: 'Everything in Team, plus',
//       items: ['Designated customer success manager', 'Priority support', 'Onboarding, implementations and operations guidance', 'Custom NLP / NLU']
//     }
//   ]
// ]

// export const featuresTables = [
//   [
//     ['Usage', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//     ['projects', '100', 'Unlimited', 'Unlimited', 'Unlimited'],
//     ['channels', 'Unlimited', 'Unlimited', 'Unlimied', 'Unlimited'],
//     ['team memmbers', 'Just you', 'Just you', 'Unlimited', 'Unlimited'],
//     ['Monthly active users (MAU) included', 2500, 5000, 10000, 'Custom'],
//     ['Each additional MAU per month', 'Upgrade to Personal Pro', '$0.025', '$0.02', 'Custom']
//   ],
//   [
//     ["Storage & Analytics", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//     ['storage', '1 GB', 'Unlimited', 'Unlimited', 'Unlimited'],
//     ['Analytics', 'Yes', 'Yes', 'Yes', 'Yes'],
//     ['Conversation history', '3 months', '1 year', 'Unlimited', 'Unlimited']
//   ],
//   [
//     ["Features", 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//     ['team collaboration', 'No', 'No', 'Yes', 'Yes'],
//     ['templates', 'Standard', 'Standard', 'Premium', 'Premium'],
//     ['sandbox', 'yes', 'yes', 'yes', 'yes'],
//     ['languages', 'Up to 2', 'Up to 4', 'Maximum', 'Maximum'],
//     ['Publishing service', 'yes', 'yes', 'yes', 'yes']
//   ],
//   [
//     ['Support & Customer', 'Personal', 'Personal Pro', 'Team', 'Enterprise'],
//     ['Access to customer support', 'Standard', '24/7 support', '24/7 support', '24/7 priority support'],
//     ['Support channels', 'Email', 'Email & chat', 'Email & chat', 'Email, chat and phone'],
//     ['Designated customer success manager', 'No', 'No','No','Yes'],
//     ['Custom natural language processing / understanding', 'No', 'No','No','Yes'],
//     ['Onboarding guidance', 'No', 'No','No','Yes'],
//     ['Implemention and expert guidance', 'No', 'No','No','Yes'],
//     ['Operations guidance', 'No', 'No','No','Yes']
//   ]
// ]